<div class="chart-container">
    <highcharts-chart
            *ngIf="!isLoading && totalAlerts && totalAlerts > 0"
            [options]="chartModel"
            [Highcharts]="Highcharts"
    >
    </highcharts-chart>
</div>
